import { render, staticRenderFns } from "./StudipIcon.vue?vue&type=template&id=155c9b58&"
import script from "./StudipIcon.vue?vue&type=script&lang=js&"
export * from "./StudipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155c9b58')) {
      api.createRecord('155c9b58', component.options)
    } else {
      api.reload('155c9b58', component.options)
    }
    module.hot.accept("./StudipIcon.vue?vue&type=template&id=155c9b58&", function () {
      api.rerender('155c9b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/StudipIcon.vue"
export default component.exports